import { useContext } from 'react'
import Head from 'next/head'
import { truncate } from 'utils/generalUtils'
import { AppContext } from 'contexts/AppContext'

type ListingSeoProps = {
  title: string
  ogTitle: string
  description: string
  canonicalUrl: string
  avatarLarge: string
}

export const ListingSEO = ({
  title,
  ogTitle,
  description,
  canonicalUrl,
  avatarLarge,
}: ListingSeoProps) => {
  const truncatedDescription = truncate(description, 500, true)
  const { site } = useContext(AppContext)
  const siteName = site.name

  return (
    <Head>
      {title && <title>{title}</title>}
      <link href={canonicalUrl} rel='canonical' />
      <meta property='og:url' content={canonicalUrl} key='og:url' />
      <meta property='og:title' content={ogTitle} key='og:title' />
      <meta name='description' content={truncatedDescription} key='description' />
      <meta property='og:desecription' content={truncatedDescription} key='og:description' />
      <meta property='og:site_name' content={siteName} key='og:site_name' />
      <meta property='og:locale' content='en_US' key='og:locale' />
      <meta property='og:image' content={avatarLarge} key='og:image' />
    </Head>
  )
}
